<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div id="campaignStep2">
        <!--<importer v-model="showImporter" @changeSelectedList="selectedList = $event" :requiredListName="true"></importer>-->
        <ImporterNew
          v-model="showImporterDialog"
          importType="campaigns"
          main-color="kbPurple"
          type="campaigns"
        />
        <v-row>
            <v-col cols="12" class="text-center mt-4 ">
                <h3 class="text-center kbDarkBlueText--text">{{ $t('general.people') }}</h3>
                <span class="kbDarkBlueText--text">{{ $t('general.pickOrCreateListOfPeopleToCommunicateMessage') }}</span>
            </v-col>

            <v-col cols="12">
                <v-row class="mx-2"  justify="center" >
                    <v-autocomplete :value="selectedList"
                                    color="kbDarkBlueText"
                                    style="max-width: 500px"
                                    class="py-6"
                                    hide-details
                                    outlined
                                    :items="listsPersonsWithAll"
                                    item-text="name"
                                    item-value="_id"
                                    :label="$t('general.pickPeopleList')"
                                    return-object
                                    single-line
                                    :search-input.sync="search"
                                    clearable
                                    @change="onSelectedListChange">
                    </v-autocomplete>
                </v-row>
            </v-col>

            <v-row>
                <v-col cols="5">
                    <v-divider></v-divider>
                </v-col>

                <v-col class="text-center d-flex align-center" cols="2" >
                    <v-row align="center" justify="center">
                        O
                    </v-row>
                </v-col>

                <v-col cols="5">
                    <v-divider/>
                </v-col>
            </v-row>

            <v-col class="text-center" cols="12" >
                <v-btn large color="kbPurple" dark @click="showImporter()">
                    <v-icon class="hidden-xs-only" left>group_add</v-icon>
                    {{ $t('general.importPeople') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-divider class="mt-4 mb-4" ></v-divider>
        <v-row class="fill-height" align="center" justify="center"  >
            <v-col cols="12" class="text-center" >
                <v-btn color="kbGrayText"
                       @click="updateStep(1)"
                       outlined
                       class="float-left">
                    <v-icon dark>keyboard_arrow_left</v-icon>
                    <span class="hidden-xs-only">{{ $t('general.goBack') }}</span>
                </v-btn>
                <v-btn color="kbPurple"
                       dark
                       @click="updateStep(3)"
                       class="float-right">
                    <span class="hidden-xs-only">{{ $t('general.continue') }}</span>
                    <v-icon dark>keyboard_arrow_right</v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import ImporterNew from '@/components/ui/ImporterNew/ImporterNew'
import { mapState } from 'vuex'
import { EventBus } from '@/eventBus'
import notifications from '@/libs/notifications'
export default {
  components: { ImporterNew },
  async created () {
    this.setListsPersonsPagination()
    await this.getListPersons()
    if (this.$route.query.list) this.selectedList = this.$route.query.list

    EventBus.$on('updateCampaign', (list) => {
      this.getListPersons().then(() => {
        this.selectedList = list
      })
    })
  },
  computed: {
    ...mapState({
      importerProgress: state => state.listsPersons.importerProgress,
      listsPersons: state => state.listsPersons.listsPersons
    }),
    listsPersonsWithAll () {
      let listsPersons = [{ name: this.$t('general.allPeople'), _id: 'all' }]
      listsPersons = listsPersons.concat(this.listsPersons)
      return listsPersons
    },
    search: {
      get () {
        return this.$store.state.listsPersons.searchListsPersons
      },
      set (value) {
        this.$store.commit('SET_SEARCH_LISTS_PERSONS', value)
      }
    }
  },
  data () {
    return {
      allPeople: {
        description: this.$t('general.allPeople'),
        value: 'all'
      },
      selectedList: '',
      showImporterDialog: false
    }
  },
  props: ['step'],
  methods: {
    async getListPersons () {
      try {
        await this.$store.dispatch('getListsPersons')
      } catch (e) {
        notifications.error(e)
      }
    },
    onSelectedListChange (list) {
      this.selectedList = list
    },
    setListsPersonsPagination () {
      this.$store.commit('SET_PAGINATION_LISTS_PERSONS', {
        limit: 100
      })
    },
    updateStep (step) {
      if (!this.importerProgress.finish && this.importerProgress.show) return notifications.error(this.$t('general.waitWhileTheListGetsCreated'))
      if (!this.selectedList && step === 3) return notifications.error(this.$t('general.noPeopleListPicked'))
      this.$emit('interface', step)
    },
    addSegmentAction () {
      this.conditions.push({
        type: 'action'
      })
    },
    addSegmentAttribute () {
      this.conditions.push({
        type: 'attribute'
      })
    },
    removeConditions (index) {
      this.conditions.splice(index, 1)
    },
    showImporter () {
      if (!this.importerProgress.finish && this.importerProgress.show) return notifications.error(this.$t('general.waitWhileTheListGetsCreated'))
      this.$store.commit('SET_IMPORTER_SELECTION', 'nueva')
      this.showImporterDialog = true
    }
  },
  watch: {
    search (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getListPersons()
      }
    },
    selectedList (value) {
      this.$emit('changeSelectedList', value)
    }
  }
}
</script>

<style>
    #campaignStep2 .exit-button {
        position: absolute !important;
        top: -13px !important;
        right: -13px !important;
    }
</style>
